import { isArray } from 'util';

import { Proof } from '../proof';

export class ProofBuilder {
  static fromJson(json) {
    return (json)
      ? new Proof(
        json.hash,
        json.name,
        json.description,
        json.isActive
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ProofBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/proof.builder.ts